import { render } from "./MasterDataRowsForm.vue?vue&type=template&id=b3ff2f28&ts=true"
import script from "./MasterDataRowsForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataRowsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__